import { Form, Input, Modal, Select } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { useEffect } from 'react';
import {
  AnnotationDetection,
  GetFloorPlanWebQuery,
} from '../../../__generated__/graphql';
import { AREA_TYPES } from '../../../common/constants';
import { DetectionType } from '../../../types/reportAnnotationScreen.type';

const EditDetectionModal = ({
  open,
  onClose,
  onUpdate,
  detection,
  parentOptions,
  parentDetectionsData,
  updatedDetections,
}: {
  open: boolean;
  onClose: () => void;
  onUpdate: (updated: DetectionType) => void;
  detection: DetectionType | null;
  parentOptions: { label: string; value: string }[];
  parentDetectionsData: GetFloorPlanWebQuery;
  updatedDetections: (AnnotationDetection | null)[];
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (detection) {
      form.setFieldsValue({
        parentID: detection.parentID ?? null,
        title: detection.title ?? '',
      });
    }
  }, [detection]);

  const handleOk = () => {
    let updatedBbox = detection?.bbox || [50, 50, 150, 150];
    form.validateFields().then((values) => {
      if (
        values?.parentID &&
        detection?.parentID &&
        values?.parentID !== detection?.parentID
      ) {
        let selectedParent = null;

        if (values.parentID) {
          selectedParent =
            parentDetectionsData?.getFloorPlanWeb?.annotation?.parentTypes?.find(
              (parent) => parent?.parentID === values.parentID,
            );

          if (!selectedParent) {
            const parentDetection = updatedDetections.find(
              (detection) =>
                detection?.childID === values.parentID && !detection?.parentID,
            );

            if (parentDetection) {
              selectedParent = {
                title: parentDetection.title,
                parentID: parentDetection.childID,
                parentType: parentDetection.childType,
                bbox: parentDetection.bbox,
              };
            }
          }
        }

        if (selectedParent?.bbox && selectedParent.bbox.length >= 2) {
          const [parentX, parentY] = selectedParent.bbox;

          const currentBbox = detection?.bbox || [50, 50, 150, 150];
          const childWidth = (currentBbox[2] || 150) - (currentBbox[0] || 50);
          const childHeight = (currentBbox[3] || 150) - (currentBbox[1] || 50);

          updatedBbox = [
            parentX || 0,
            parentY || 0,
            (parentX || 0) + childWidth,
            (parentY || 0) + childHeight,
          ];
        } else if (values.parentID === null) {
          updatedBbox = detection?.bbox || [50, 50, 150, 150];
        } else {
          const currentBbox = detection?.bbox || [50, 50, 150, 150];
          const childWidth = (currentBbox[2] || 150) - (currentBbox[0] || 50);
          const childHeight = (currentBbox[3] || 150) - (currentBbox[1] || 50);
          updatedBbox = [50, 50, 50 + childWidth, 50 + childHeight];
        }

        onUpdate({
          ...detection,
          parentID: values?.parentID ?? null,
          title: values?.title ?? '',
          childType: detection?.childType ?? '',
          childID: detection?.childID ?? '',
          bbox: updatedBbox,
        });
      } else {
        onUpdate({
          ...detection,
          parentID: values?.parentID ?? null,
          title: values?.title ?? '',
          childType: detection?.childType ?? '',
          childID: detection?.childID ?? '',
          bbox: detection?.bbox || updatedBbox,
        });
      }
      onClose();
    });
  };
  return (
    <Modal
      title="Edit Detection"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText="Update"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: 'Title is required' }]}
          className="custom-label"
        >
          <Input />
        </Form.Item>
        {parentOptions?.length > 0 && (
          <Form.Item name="parentID" label="Parent" className="custom-label">
            <Select
              options={
                [
                  detection?.childType === AREA_TYPES.BATHROOM
                    ? { label: 'None', value: null }
                    : null,
                  ...parentOptions,
                ].filter(Boolean) as DefaultOptionType[]
              }
              allowClear
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default EditDetectionModal;
